import { render, staticRenderFns } from "./EtapaIARA.vue?vue&type=template&id=85484ce0&scoped=true&lang=pug"
import script from "./EtapaIARA.vue?vue&type=script&lang=js"
export * from "./EtapaIARA.vue?vue&type=script&lang=js"
import style0 from "./EtapaIARA.vue?vue&type=style&index=0&id=85484ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85484ce0",
  null
  
)

export default component.exports